import type { Payer } from "src/__generated__/base.gql";
import { INSURER } from "../InsurerAccordion/formConstants";

export const getPrintableInvoices = (
  invoicesToPrint: string[],
  payers: Payer[],
) => {
  if (payers?.length === 1 && payers.filter((p) => p.type === INSURER)) {
    return payers.filter((p) => p.type === INSURER);
  }
  if (invoicesToPrint?.length > 0) {
    return payers.filter((p) =>
      invoicesToPrint.includes(p?.insuranceDetails?.name || p.name),
    );
  }
  return payers;
};
